import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { TestlistService } from '@app-services/test/testlist.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-chapterinsight',
  templateUrl: './chapterinsight.component.html',
  styleUrls: ['./chapterinsight.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ChapterinsightComponent implements OnInit {
@Input('testReport') public testReport:any ={};
@Input('QuestionsData') public QuestionsData:any ={};
@Input('examRanges') public examRanges:any ={};
@Input('viewSolutionAvailableTimebound') public viewSolutionAvailableTimebound:any = false
public testReportCopy :any ={}
  public accro:any ={}
public chartType:any ={
  attempted:{
    color:'#AFD7BE',
  },
  incorrect:{
    color:'#F5C8C8',
  },
  unattempted:{
    color:'#ECEDF4',
  },
}
public getbtnName:any='strong';
public getSubjectName:any;
public chaptersData :any = []
// public examRanges = {};
public selectedSubject:any =''
couraselHeight:any =200;
  totalSubjects: any;
  constructor(private testListService: TestlistService,private mrkchage:ChangeDetectorRef,public spinner :NgxSpinnerService) { }

  ngOnInit(): void {
    // this.testListService.getReportTemplate().subscribe((response:any) => {
      // let exam_type = this.testReportCopy?.exam_type||this.testReport?.examtype;
    //  this.examRanges =  exam_type == 1 ? response?.data?.neet:response?.data?.jeeMains;   
    this.testReportCopy = {...this.testReport} 	
      this.filterQuestionBasedOnchapter()
    // })
  }
  filterQuestionBasedOnchapter(){
      this.testReportCopy?.testSubjects?.forEach(v=>{
      let particularSubjectQuestions =   this.QuestionsData?.questions?.subjects.find(q=> v.subjectName?.toLowerCase()== q?.subjectname?.toLowerCase())
        v.chapters?.sort((a,b)=>a?.totalScore - b?.totalScore)?.forEach((c)=>{
          let singleChapter = particularSubjectQuestions?.questions?.map((cq,i)=>{return {...cq,letter:i+1}})?.filter(cq=>cq?.chapter == c?.chapter)
          c.correctAnswer = singleChapter?.filter(sc=>sc.iscorrect =='Y')?.map((sc)=>{ return {...sc,frequency: sc?.timeTaken}});
          c.incorrectAnswer = singleChapter?.filter(sc=>sc.iscorrect =='N')?.map((sc)=>{ return {...sc,frequency: sc?.timeTaken}});
          c.unattempted = singleChapter?.filter(sc=>sc.iscorrect !='N' && sc.iscorrect !='Y')?.map((sc)=>{ return {...sc,frequency: sc?.timeTaken}});
          c.totalchapterquestion=singleChapter?.length
        })
      })
      this.totalSubjects =this.testReportCopy?.testSubjects?.map(v=>v.subjectName)
      this.selectedSubject = this.totalSubjects?.[0];
      this.subjectChange()
  }
  subjectChange(){
    // this.loadChapter(this.getbtnName)
    this.chaptersData =[]
    let buttonTypes= ['strong','good','improve']
    for (let index = 0; index < buttonTypes.length; index++) {
      let  temp_chapters = this.FilterchapterData( buttonTypes[index]);
      if(temp_chapters?.length){
        this.loadChapter(buttonTypes[index])
        break;
      }
    }
    this.mrkchage.detectChanges()
  }
  loadChapter( btnName, e?) {
    e?.preventDefault();
    e?.stopPropagation();
    this.getbtnName = btnName; 
    this.chaptersData = [];   
    setTimeout(() => { 
      this.chaptersData = this.FilterchapterData(this.getbtnName)?.slice(0,5)
      if(btnName !=='improve'){
        this.chaptersData = this.chaptersData?.reverse()
      }
      this.chaptersData.forEach(v=>{
        v.open=true;
      })
      if(this.chaptersData?.length ==1){
        this.chaptersData[0].open = true
      }
      setTimeout(() => {
        this.couraselHeight =this.chaptersData?.some(v=>v.open)? 525 : 86
        this.mrkchage.detectChanges()
      }, 0);
    }, 0);   
  }
  changeCarouselHeight( index,e?){    
    e?.preventDefault();
    e?.stopPropagation();
    this.chaptersData[index].open = !this.chaptersData[index].open
    setTimeout(() => {
      this.couraselHeight =this.chaptersData?.some(v=>v.open)? 525 : 86
      this.mrkchage.detectChanges()
    }, 0);
  }
  FilterchapterData(btnName){
    let subjectNae =  this.selectedSubject?.toLowerCase()?.replaceAll(' ','');
    if(this.selectedSubject?.toLowerCase() == 'mathematics'  && !this.examRanges?.[this.selectedSubject?.toLowerCase()]){
      subjectNae = 'maths' 
    }
    let filterRange = this.examRanges?.[subjectNae]
    return this.testReportCopy.testSubjects?.find(v => v?.subjectName == this.selectedSubject)?.chapters?.filter((v, i) => {
      return (v?.percentage > filterRange?.[btnName]?.min || v?.percentage == filterRange?.[btnName]?.min) && (v?.percentage < filterRange?.[btnName]?.max ||( v?.percentage == filterRange?.[btnName]?.max &&  filterRange?.[btnName]?.max == 100))
    })?.sort((a,b)=>b?.percentage - a?.percentage)
  }
  ngOnChanges(){
    this.testReportCopy = {...this.testReport} 
    this.filterQuestionBasedOnchapter()
  }
}
